import Collaboration from "../components/Collaboration";
import ListChild from "../components/ListChild";
import PageTitle from "../components/PageTitle";
import ShopFilter from "../components/ShopFilter";
import { useState } from "react";
import {
  BsCheck,
  BsFillStarFill,
  BsSearch,
  BsFillRecordFill,
} from "react-icons/bs";
import Rating from "react-rating";

const ProductBrand = [
  {
    id: 1,
    text: "Coaster Furniture",
  },
  {
    id: 2,
    text: "Fusion Dot High Fashion",
  },
  {
    id: 3,
    text: "Unique Furniture Restor",
  },
  {
    id: 4,
    text: "Dream Furniture Flipping",
  },
  {
    id: 5,
    text: "Young Repurposed",
  },
  {
    id: 5,
    text: "Green DIY furniture",
  },
];

const discountOffer = [
  {
    id: 1,
    text: "20% Cashback offer",
  },
  {
    id: 2,
    text: "5% Cashback Offer",
  },
  {
    id: 3,
    text: "25% Discount Offer",
  },
];

const itemsRating = [
  {
    id: 1,
    text: (
      <Rating
        className="ml-3"
        initialRating="5"
        readonly
        fullSymbol={<BsFillStarFill className="mx-1" color="#FFC416" />}
        emptySymbol={<BsFillStarFill className="mx-1" color="gray" />}
      />
    ),
  },
  {
    id: 2,
    text: (
      <Rating
        className="ml-3"
        initialRating="4"
        readonly
        fullSymbol={<BsFillStarFill className="mx-1" color="#FFC416" />}
        emptySymbol={<BsFillStarFill className="mx-1" color="gray" />}
      />
    ),
  },
  {
    id: 3,
    text: (
      <Rating
        className="ml-3"
        initialRating="3"
        readonly
        fullSymbol={<BsFillStarFill className="mx-1" color="#FFC416" />}
        emptySymbol={<BsFillStarFill className="mx-1" color="gray" />}
      />
    ),
  },
  {
    id: 4,
    text: (
      <Rating
        className="ml-3"
        initialRating="2"
        readonly
        fullSymbol={<BsFillStarFill className="mx-1" color="#FFC416" />}
        emptySymbol={<BsFillStarFill className="mx-1" color="gray" />}
      />
    ),
  },
  {
    id: 5,
    text: (
      <Rating
        className="ml-3"
        initialRating="1"
        readonly
        fullSymbol={<BsFillStarFill className="mx-1" color="#FFC416" />}
        emptySymbol={<BsFillStarFill className="mx-1" color="gray" />}
      />
    ),
  },
];

const priceFilter = [
  {
    id: 1,
    text: "$0.00 - $150.00",
  },
  {
    id: 2,
    text: "$150.00 - $350.000",
  },
  {
    id: 3,
    text: "$350.00 +",
  },
];

function ShopLeftSidebar() {
  return (
    <>
      <PageTitle
        title="Shop Left Sidebar"
        path={["Pages ", "Shop Left Sidebar"]}
      />
      <ShopFilter />
      <div className="max-w-5xl mx-auto flex">
        {/* left side */}
        <ul className="w-52 text-sub_text_color mr-5">
          <ul className=" mb-12">
            <h2 className="font-bold underline text-xl text-text mb-4">
              Product Brand
            </h2>
            {ProductBrand.map((value) => (
              <BlueCheckBox key={value.id}>{value.text}</BlueCheckBox>
            ))}
          </ul>
          {/*  */}
          <ul className=" mb-12">
            <h2 className="font-bold underline text-xl text-text mb-4">
              Discount Offer
            </h2>
            {discountOffer.map((value) => (
              <PinkCheckBox key={value.id}>{value.text}</PinkCheckBox>
            ))}
          </ul>
          {/*  */}
          <ul className=" mb-12">
            <h2 className="font-bold underline text-xl text-text mb-4">
              Rating Item
            </h2>
            {itemsRating.map((value) => (
              <YellowCheckBox key={value.id}>{value.text}</YellowCheckBox>
            ))}
          </ul>
          {/*  */}
          <ul className=" mb-12">
            <h2 className="font-bold underline text-xl text-text mb-4">
              Price Filter
            </h2>
            {priceFilter.map((value) => (
              <PinkCheckBox key={value.id}>{value.text}</PinkCheckBox>
            ))}
            <div className="flex  items-center px-2 py-2 border rounded-md">
              <input
                placeholder="$10.00 - $2000.00"
                className=" flex-1 focus:outline-none bg-[rgba(0,0,0,0)] text-gray-400 text-sm "
              />
              <BsSearch />
            </div>
          </ul>
          {/*  */}
          <ul className=" mb-12">
            <h2 className="font-bold underline text-xl text-text mb-4">
              Price Filter
            </h2>
            <div className="grid grid-cols-3 ">
              <div className="flex items-center text-sm">
                <BsFillRecordFill size={15} className="mr-1" color="#5E37FF" />
                Blue
              </div>
              <div className="flex items-center text-sm">
                <BsFillRecordFill size={15} className="mr-1" color="#FF9437" />
                Orange
              </div>
              <div className="flex items-center text-sm">
                <BsFillRecordFill size={15} className="mr-1" color="#FFBF95" />
                Brown
              </div>
              <div className="flex items-center text-sm">
                <BsFillRecordFill size={15} className="mr-1" color="#33D221" />
                Green
              </div>
              <div className="flex items-center text-sm">
                <BsFillRecordFill size={15} className="mr-1" color="#E248FF" />
                Purpule
              </div>
              <div className="flex items-center text-sm">
                <BsFillRecordFill size={15} className="mr-1" color="#26CBFF" />
                Sky
              </div>
            </div>
          </ul>
        </ul>
        {/* right side */}
        <div className=" flex-1">
          <ListChild img={require("../assets/shop-list/img01.png")} />
          <ListChild img={require("../assets/shop-list/img02.png")} />
          <ListChild img={require("../assets/shop-list/img03.png")} />
          <ListChild img={require("../assets/shop-list/img04.png")} />
        </div>
      </div>
      <Collaboration />
    </>
  );
}

function BlueCheckBox({ children }) {
  const [checked, setChecked] = useState();
  return (
    <label className="flex items-center mb-2">
      <div className="relative w-4 h-4 mr-2 p-0 -translate-y-[2px]">
        <input
          className={`${
            checked ? "bg-[#603EFF]" : "bg-[#E5E0FC]"
          } appearance-none h-full w-full rounded-sm`}
          type="checkbox"
          onChange={(e) => {
            setChecked(e.target.checked);
          }}
        />
        <BsCheck
          className="absolute top-[2px] left-0 "
          color={checked ? "white" : "#603EFF"}
        />
      </div>
      {children}
    </label>
  );
}

function YellowCheckBox({ children }) {
  const [checked, setChecked] = useState();
  return (
    <label className="flex items-center mb-2">
      <div className="relative w-4 h-4 mr-2 p-0 -translate-y-[2px]">
        <input
          className={`${
            checked ? "bg-[#FFCC2E]" : "bg-[#FFF6DA]"
          } appearance-none h-full w-full rounded-sm`}
          type="checkbox"
          onChange={(e) => {
            setChecked(e.target.checked);
          }}
        />
        <BsCheck
          className="absolute top-[2px] left-0 "
          color={checked ? "white" : "#FFCC2E"}
        />
      </div>
      {children}
    </label>
  );
}
function PinkCheckBox({ children }) {
  const [checked, setChecked] = useState();
  return (
    <label className="flex items-center mb-2">
      <div className="relative w-4 h-4 mr-2 p-0 -translate-y-[2px]">
        <input
          className={`${
            checked ? "bg-[#FF3EB2]" : "bg-[#FFDBF1]"
          } appearance-none h-full w-full rounded-sm`}
          type="checkbox"
          onChange={(e) => {
            setChecked(e.target.checked);
          }}
        />
        <BsCheck
          className="absolute top-[2px] left-0 "
          color={checked ? "white" : "#FF3EB2"}
        />
      </div>
      {children}
    </label>
  );
}

export default ShopLeftSidebar;
